import FileUploader from 'scoreboard/components/files/file-uploader'
import _ from 'lodash'
import i18n from 'scoreboard/components/i18n'
import fileAttachmentContent from 'scoreboard/components/files/file-attachment-content.hbs'
import ScanningIcon from 'scoreboard/components/scanning-icon'

/**
 * An animated uploader is used for cases when there is some extra processing done after the file has been uploaded
 * and the progress of that extra processing needs to be shown. Ex: Datasets file upload.
 */

var AnimatedFileUploader = FileUploader.extend({
	className: FileUploader.prototype.className + ' animated-file-uploader',

	states: _.extend({}, FileUploader.prototype.states, {
		SCANNING: 'file-uploader-state-is-scanning',
		DONE: 'file-uploader-state-is-done'
	}),

	views: [{
		detailIcon: 'docs-spreadsheet-transparent',
		class: 'file-uploader-view-uploading',
		hasFileInfo: true
	},{
		detailIcon: 'docs-spreadsheet-transparent',
		class: 'file-uploader-view-scanning'
	},{
		detailIcon: '',
		class: 'file-uploader-view-done is-centered'
	}],

	initialize: function(options) {
		FileUploader.prototype.initialize.apply(this, arguments)
		this.iconUploading = options.iconUploading || new ScanningIcon()
		this.iconScanning = options.iconScanning || new ScanningIcon()
		this.iconDone = options.iconDone || new ScanningIcon()
	},

	render: function() {
		FileUploader.prototype.render.apply(this, arguments)
		this.$('.file-attachment-content').append(fileAttachmentContent())
		// Customize the scanning text
		var scanningText = i18n.get('datasets.scanningFile')
		let isSpreadsheet = _.includes(this.options.accept, 'spreadsheet') ||
			_.includes(this.options.accept, 'spreadsheetWithoutNumbers')
		if (this.options.accept && isSpreadsheet) {
			scanningText = i18n.get('datasets.scanningSpreadsheet')
		}
		this.$('.file-uploader-view-done .label').text(i18n.get('common.done'))
		this.$('.file-uploader-view-scanning .label').text(scanningText)

		// Replace the spreadsheet icons in the uploading/scanning/done detail views with the iconScanning.
		// The scanning icon animates while the upload/done ones do not.
		this.$('.file-uploader-view-uploading svg').replaceWith(this.iconUploading.el)
		this.iconUploading.render()
		this.$('.file-uploader-view-scanning svg').replaceWith(this.iconScanning.el)
		this.iconScanning.render()
		this.$('.file-uploader-view-done svg').replaceWith(this.iconDone.el)
		this.iconDone.render()

		// We need to wait here for the DOM to update or else the iconScanning will not initialize properly
		process.nextTick(() => {
			// init and pause both icons. The one used for the uploading state will remain paused
			// and the one used for the scanning state will be started/restarted when that state is visible
			// so that it doesn't appear mid-animation.
			this.iconUploading.init()
			this.iconUploading.pause()
			this.iconScanning.init()
			this.iconScanning.pause()
			this.iconDone.init()
			this.iconDone.pause()

			// If there are files already registered in this input, set the state to reflect that
			if (this.files && this.files.length > 0) {
				// Use the UPLOADING state here since the file info is visible as well as the .reset (x)
				// button to cancel things out and upload another file
				this.setState(this.states.UPLOADING)
			}
		})
		return this
	},

	applyNewState: function(newState) {

		// If we're entering the SCANNING state, wait for the previous state to finish
		// fading out to bring it to center
		if (this.state == this.states.UPLOADING && newState == this.states.SCANNING ||
			this.state == this.states.DONE && newState == this.states.SCANNING) {
			this.$('.file-uploader-view-scanning').addClass('is-centered')

			// Wait till after the .file-uploader-view-scanning fades in to
			// start/restart the 'scanning' animation
			this.$('.file-uploader-view-scanning .file-attachment-details').one('transitionend', () => {
				// The 'slide-in' effect has a transition delay of .2s, so in order
				// to start the 'scanning' animation when the icon+text are in the center,
				// wait an extra split second.
				// This delay should match $animation-animated-file-uploader-slide-in in animations.scss
				setTimeout(() => this.iconScanning.restart(), 200)
			})
		}

		// Remove the .is-centered class from the .file-uploader-view-scanning
		// if we're leaving the SCANNING state so that it'll animate again if needed.
		if (newState != this.states.SCANNING) {
			this.$('.file-uploader-view-scanning').removeClass('is-centered')
			this.iconScanning?.pause(0)
		}

		FileUploader.prototype.applyNewState.apply(this, arguments)
	},

	setState: function(state) {
		if (this.state == state) {
			return
		}

		this.removeStateClasses()
		this.applyNewState(state)
	},

	progress: function(percent) {
		FileUploader.prototype.progress.apply(this, arguments)

		if (percent >= 100) {
			this.setState(this.states.SCANNING)
		}
	},

	reset: function(e) {
		FileUploader.prototype.reset.apply(this, arguments)
		this.$('.reset').removeClass('is-not-displayed')
	},

	uploadFinished: function(data) {
		FileUploader.prototype.uploadFinished.apply(this, arguments)
		// Wait an extra moment in order to display the 'done' view
		this.setState(this.states.DONE)

		// After 1sec, change the 'done' view back to the uploading view
		// so that we can see the file info
		setTimeout(() => this.setState(this.states.UPLOADING), 1000)
	}
})

export default AnimatedFileUploader

AnimatedFileUploader.__filename__ = 'components/files/animated-file-uploader.js'
